import { apiClient } from "lib/apiClient";

export interface ICancelResearchDemandRequest {
  demandId: string;
  version: number;
}

export interface ICancelResearchDemandResponse {
  workItemId: string;
  removed: boolean;
}

export const cancelResearchDemand = async ({
  demandId,
  version,
}: ICancelResearchDemandRequest): Promise<ICancelResearchDemandResponse> => {
  const response = await apiClient.post(
    `/research/demands/${demandId}/cancellation`,
    { version }
  );

  return response.data;
};
